import { render, staticRenderFns } from "./FaqBox.vue?vue&type=template&id=2e1474c0&"
import script from "./FaqBox.vue?vue&type=script&lang=ts&"
export * from "./FaqBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports